export default {
  // tab
  dbs_subtitle_portfolio_overview: 'Portfolio Overview',
  dbs_subtitle_studios: 'Studios',
  dbs_subtitle_live_titles: 'Live Titles',
  dbs_subtitle_in_dev_projects: 'In Dev Projects',
  // 1.0 Portfolio Overview tab
  dbs_total_revenue_studio: 'Total Gross Revenue_Studio',
  dbs_total_revenue: 'Total Gross Revenue',
  dbs_total_profit_studio: 'Total Profit_Studio',
  dbs_total_profit: 'Total Profit',
  dbs_button_board_governance: 'Board Governance',
  dbs_more_board: 'More Board/General Resolution',
  dbs_action_note: 'Action & Note',
  dbs_opportunities_risks: 'Opportunities & Risks',
  dbs_table_allTotal: 'All Total',
  dbs_table_phase3Total: 'Phase 3 Total',
  dbs_table_phase2Total: 'Phase 2 Total',
  dbs_table_phase1Total: 'Phase 1 Total',
  dbs_table_functionTotal: 'Function Total',
  dbs_gross_revenue_trend: 'Gross Revenue Trend',
  dbs_profit_trend: 'Profit Trend',
  dbs_table_phase_studio: 'Phase/Studio',
  dbs_pipeline_calendar: 'Pipeline Calendar in',
  // 2.0 Studios tab
  dbs_studios_by_month: 'By Month',
  dbs_studios_by_year: 'By Year',
  dbs_studios_headcount: 'Headcount',
  dbs_studios_staff_rate: 'Staff Rate',
  dbs_studios_headcount_tab_tip: 'Actual HC is sourced from RP, while Forecast HC is sourced from Finance.',
  dbs_studios_headcount_level_1: 'Level 1 Category',
  dbs_studios_headcount_level_2: 'Level 2 Category',
  dbs_studios_headcount_functions: 'Functions',
  dbs_studios_headcount_level_1_tip: 'Highest-level workforce classification by employment type, such as FTE and Temporary.',
  dbs_studios_headcount_level_2_tip: 'Workforce classification by business area under Level 1, such as Management, R&D, S&M, and Functional Support.',
  dbs_studios_headcount_functions_tip: 'Most granular workforce classification by team or job function, such as Design, Customer Service, and Technology and Research.',
  dbs_studios_headcount_fte: 'FTE',
  dbs_studios_headcount_temporary: 'Temporary',
  dbs_studios_headcount_fte_total: 'FTE Total',
  dbs_studios_headcount_temporary_total: 'Temporary Total',
  dbs_studios_headcount_management: 'Management',
  dbs_studios_headcount_functional_support: 'Functional Support',
  dbs_studios_headcount_technology_and_research: 'Technology and Research',
  dbs_studios_headcount_product_management: 'Product Management and Business Operations and Development',
  dbs_studios_headcount_design: 'Design',
  dbs_studios_headcount_sales_and_marketing: 'Sales and Marketing',
  dbs_studios_headcount_customer_service: 'Customer Service',
  dbs_studios_headcount_intern: 'Intern',
  dbs_studios_headcount_contractor: 'Contractor',
  dbs_studios_headcount_others: 'Others',
  dbs_boardmeeting: 'Board Meeting',
  dbs_studio_financials: 'Studio Financials',
  dbs_financials: 'Financials',
  dbs_burn_rate: 'Burn Rate',
  dbs_studio_calendar: 'Studio Calendar in',
  dbs_studio_no_board_governance: '该工作室暂时没有 Board Governance 会议信息。',
  // 3.0 Live Titles tab
  dbs_button_data_analytics: 'Data Analytics',
  dbs_filter_platform: 'Platform',
  dbs_filter_region: 'Region',
  dbs_aggregated_by_selected_period: 'Aggregated by selected period',
  // 4.0 In Dev Tab
  dbs_budget_to_next_milestone: 'Estimated Total Dev Cost',
  dbs_overall_budget: 'Approved Total Dev Cost',
  dbs_planned_current_milestone: 'Planned - Current Milestone',
  dbs_planned_next_milestone: 'Planned - Next Milestone',
  dbs_gr_management: 'GR Management',
  dbs_studios_by_phase: 'By Phase',
  dbs_dev_cost: 'Dev Cost',
  dbs_mkt_cost: 'Mkt Cost',
  dbs_other_cost: 'Other Cost',
  dbs_total_dev_cost: 'Total Dev Cost',
  dbs_cum_profit_break_even: 'Cum. Profit / Break even',
  dbs_life_cycle_financial_forecast: 'Life Cycle Financial Forecast',
  dbs_rd: 'R&D',
  dbs_sm: 'S&M',
  dbs_le_liveops: 'LiveOps',
  dbs_project_calendar: 'Project Calendar',
  dbs_25A_25F_25B_data_notice: '25A, 25F and 25B are sourced from the finance database and not editable. If any updates are required, please reach out to judymao.',
  dbs_25F_25B_data_notice: '25F and 25B are sourced from the finance database and not editable. If any updates are required, please reach out to judymao.',
  dbs_cannot_delete_phase_with_studios: 'Cannot delete phase while it still contains studios',
  dbs_delete_phase_confirm: 'Are you sure you want to delete the phase?',
  dbs_cannot_delete_category_with_projects: 'Are you sure you want to delete the category?',
};
